// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__ANdA0","lds-roller":"Loader_lds-roller__3w5oo"};